module.exports = __webpack_public_path__ + "static/media/uninstall-heart-face-monochromatic.9e95ad53.png";